
    var riot = require('riot')
    //src: starling/src/tags/search-item.html
riot.tag2('search-item',
  '<li onclick="{zoomToResult}"> <span class="title">{this.title}</span> <span class="summary">{this.summary}</span> </li>',
  'search-item li,[data-is="search-item"] li{ list-style: none; display: flex; flex-direction: column; cursor: pointer; } search-item .summary,[data-is="search-item"] .summary{ font-size: 12px; color: #ddd; }',
  '', function(opts) {
"use strict";

var _this = this;

this.canvas = opts.canvas;

this.zoomToResult = function () {
  _this.canvas.setSelectedElement(_this.canvas.nodeTags[_this.id]);
  _this.canvas.fitSelectionOrMap();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('search-item')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/search-item.html
// module id = 639
// module chunks = 0